'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSlowMotionVideo = function MdSlowMotionVideo(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36.6 20q0 6.4-4.3 11.2t-10.6 5.4v-3.4q4.9-0.6 8.3-4.4t3.4-8.8-3.4-8.8-8.3-4.4v-3.4q6.3 0.7 10.6 5.4t4.3 11.2z m-27.1 12.9l2.3-2.4q2.9 2.2 6.6 2.7v3.4q-5-0.5-8.9-3.7z m-2.7-11.3q0.5 3.7 2.7 6.5l-2.4 2.5q-3.2-4-3.7-9h3.4z m2.7-9.8q-2.2 2.9-2.7 6.6h-3.4q0.5-5 3.7-8.9z m8.9-5q-3.7 0.5-6.6 2.7l-2.3-2.4q3.9-3.2 8.9-3.7v3.4z m3.3 9.5l4.9 3.7q-4.9 3.7-10 7.5z' })
        )
    );
};

exports.default = MdSlowMotionVideo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/slow-motion-video.js
// module id = 1471
// module chunks = 36573943044255 79611799117203 213534597649335